import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import PropTypes from 'prop-types';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import Css from "./SwiperSlideDev.module.css";

// import required modules
import { Mousewheel, Pagination } from "swiper/modules";

// const ImagesItems = [
//   "https://organza.ru/timthumb/508/338/upload/images/Anka/pina/7/amazonico-333/IMG_7837.JPG",
//   "https://organza.ru/timthumb/508/338/upload/images/Anka/pina/7/amazonico-333/IMG_7838.JPG",
//   "https://organza.ru/timthumb/508/338/upload/images/Anka/pina/7/amazonico-333/x-interior-amasonico-raya.jpg"
// ]

export const  SwiperSlideDev=(ImagesItems, ...props) => {


  return (
    <div className={Css.rootSlide}>
      <Swiper
        direction={"horizontal"}
        slidesPerView={1}
        spaceBetween={30}
        mousewheel={true}
        pagination={{
          clickable: true,
        }}
        modules={[Mousewheel, Pagination]}
        className={Css.mySwiper}
      >
        {ImagesItems.ImagesItems.map((item,index) => {
         return  <SwiperSlide key={index}><img src={item} /></SwiperSlide>
        })}
       
      </Swiper>
    </div>
  );
}
